import {
  Box,
  SimpleGrid,
  Text,
  VStack,
  Spinner,
} from "@chakra-ui/react";
import React from "react";
import { GridCard } from "./GridCard";
import { common } from "../../constants/constants";
import { PaginationFooter } from "../PaginationFooter";

export const GridView = ({
  data,
  fetchMoreData,
  hasMore,
  handleEdit,
  loading,
  getHref,
  onToggleVisible,
  selectable,
  isRecordSelected,
  onToggleSelect,
  currentPage,
  totalPages,
  handlePageChange,
  pagination = true,
}) => {
  return (
    <Box position="relative" flex="1" minH="0" display="flex" flexDirection="column" overflow="hidden">
      <Box
        id="scrollableDiv"
        flex="1"
        overflowY="auto"
        mt={4}
        px={1}
        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#cbd5e0",
            borderRadius: "10px",
          },
        }}
      >
        {loading && data.length === 0 ? (
          <VStack py={20} spacing={4}>
            <Spinner size="xl" color="blue.500" thickness="4px" />
            <Text fontSize="lg" fontWeight="600" color="gray.600">
              Loading...
            </Text>
          </VStack>
        ) : data.length > 0 ? (
          <SimpleGrid
            columns={{ base: 2, md: 3, lg: 4, xl: 5 }}
            spacing={{ base: 4, md: 6 }}
            pb={8}
          >
            {data.map((record, index) => (
              <GridCard
                key={record._id || index}
                record={record}
                onClick={() => handleEdit(record)}
                href={getHref ? getHref(record) : undefined}
                onToggleVisible={onToggleVisible}
                selectable={selectable}
                isSelected={isRecordSelected ? isRecordSelected(record) : false}
                onToggleSelect={(checked) => onToggleSelect && onToggleSelect(record, checked)}
              />
            ))}
          </SimpleGrid>
        ) : !loading && (
          <VStack py={20} spacing={4}>
            <Box
              w={20}
              h={20}
              bg="gray.100"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text fontSize="3xl">🔍</Text>
            </Box>
            <Box textAlign="center">
              <Text fontSize="xl" fontWeight="700" color="gray.700">
                {common.NO_DATA}
              </Text>
              <Text color="gray.500">
                Try adjusting your search or filters
              </Text>
            </Box>
          </VStack>
        )}
      </Box>

      {pagination && (
        <PaginationFooter currentPage={currentPage} totalPages={totalPages} handlePageChange={handlePageChange} />
      )}
    </Box>
  );
};
